import React from "react"
import * as Icon from "react-feather"

const horizontalMenuConfig = [

  {
    id: "forms",
    title: "Formuláře",
    type: "dropdown",
    icon: <Icon.Edit3 size={16} />,
    children: [
      {
        id: "formElements",
        title: "Správa",
        type: "dropdown",
        icon: <Icon.Copy size={16} />,
        children: [
          {
            id: "create",
            title: "Vytovřit nový",
            type: "item",
            icon: <Icon.Circle size={10} />,
            navLink: "/forms/create",
            permissions: ["admin", "editor"]
          },
          {
            id: "created",
            title: "Vytvořené",
            type: "item",
            icon: <Icon.Circle size={10} />,
            navLink: "/forms/created",
            permissions: ["admin", "editor"]
          }
        ]
      }
    ]
  } 

]

export default horizontalMenuConfig
